export const FromSubmit = (function () {
    "use strict";

    let $form, $formText;

    function init() {
        $form = $("#subscription-form form");
				$formText = $('#subscription-form .form--text')

        $form.submit(function (e) {
            e.preventDefault();

            let action = $form.attr("action");
            let postUrl = action;
            let postUrlParams = action.split("?")[1];
            let data = $form.serialize() + "&" + postUrlParams;
            let url = "/wp-content/themes/amsoil/proxy.php";
            url = url + "?url=" + escape(postUrl);

            $.ajax({
                type: "POST",
                url: url,
                data: data,
                encode: true,
            }).done(function (data) {
                console.log("ajax success: ", data);
								$formText.html('<h2 class="h4 form--msg">Thanks for subscribing</h2>');
                                $('.subscription-form.form').hide();
            }).fail(function(jqXHR, textStatus, errorThrown){
							console.log('ajax error: ',  errorThrown);
						});
        });
    }

    return {
        init: init,
    };
})();
